export default __webpack_public_path__ + "static/production-2-77b5ff8c2a7374bac978ca7c9109f51a.png";